import { ChevronDown } from "lucide-react";
import { useState } from "react";

export const NAV = [
  { group: "Monitor", items: ["Overview", "Control", "Live Watch", "Progress"] },
  {
    group: "Signals",
    items: ["Convergence", "Instruments", "Control items", "Facets", "Avoidance", "Cohort", "Influence"],
  },
  { group: "Compare", items: ["Benchmark", "Engagements", "Facet trends"] },
  { group: "Record", items: ["Rhythm", "Timeline", "Transcript"] },
  { group: "Access", items: ["Invites", "Operators"] },
  { group: "Reference", items: ["Spec"] },
];

export const MONITOR_VIEWS = ["Control", "Live Watch", "Progress"];
export const slug = (t) => t.toLowerCase().replace(/\s+/g, "-");

const Items = ({ tab, onPick }) =>
  NAV.map(({ group, items }) => (
    <div key={group} className="mb-7">
      <p className="label px-3 !text-[9px] !text-zinc-700">{group}</p>
      <ul className="mt-2">
        {items.map((t) => {
          const on = tab === t;
          return (
            <li key={t}>
              <button
                onClick={() => onPick(t)}
                data-testid={`admin-tab-${slug(t)}`}
                className={`relative w-full px-3 py-[0.55rem] text-left font-data text-[11px] tracking-[0.1em] transition-colors ${
                  on
                    ? "bg-[rgba(255,255,255,0.055)] text-zinc-100"
                    : "text-zinc-500 hover:bg-[rgba(255,255,255,0.025)] hover:text-zinc-200"
                }`}
              >
                <span
                  className={`absolute left-0 top-1/2 h-[14px] w-[2px] -translate-y-1/2 transition-opacity ${
                    on ? "bg-zinc-100 opacity-100" : "opacity-0"
                  }`}
                />
                {t}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  ));

/** Grouped navigation: a rail on desktop, a disclosure on narrow screens. */
export const OperatorNav = ({ tab, setTab }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <nav
        data-testid="operator-nav"
        className="thin-scroll hidden w-[13.5rem] shrink-0 overflow-y-auto border-r border-[var(--line)] py-8 lg:block"
      >
        <Items tab={tab} onPick={setTab} />
      </nav>

      <div className="border-b border-[var(--line)] lg:hidden">
        <button
          data-testid="operator-nav-toggle"
          onClick={() => setOpen((v) => !v)}
          className="label flex w-full items-center justify-between px-6 py-4 !text-zinc-300"
        >
          {tab}
          <ChevronDown
            size={13}
            strokeWidth={1.6}
            className={`transition-transform ${open ? "rotate-180" : ""}`}
          />
        </button>
        {open && (
          <div className="thin-scroll max-h-[60vh] overflow-y-auto px-3 pb-6">
            <Items
              tab={tab}
              onPick={(t) => {
                setTab(t);
                setOpen(false);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default OperatorNav;
